import React, { PureComponent } from 'react';
import { CurrencySelector, Checkbox } from '@cimpress/react-components';

const DISABLED_CURRENCIES = ['AUD', 'CNY', 'EUR'];

export default class CurrencySelectorDemo extends PureComponent {
  state = {
    currency: '',
    disabled: false,
    disabledCurrencies: false,
    multiCurrencySelections: null,
    symbol: '',
    displayFullName: false,
  };

  onChange = currency => {
    if (!currency) {
      return this.setState({ currency: '', symbol: '' });
    }
    const { value, symbol } = currency;
    return this.setState({ currency: value, symbol });
  };

  onChangeDisabledCurrencies = () => {
    const previousDisabledCurrencies = this.state.disabledCurrencies;
    this.setState({ disabledCurrencies: !previousDisabledCurrencies });
  };

  onChangeMultiSelect = multiCurrencySelections => {
    if (!multiCurrencySelections) return this.setState({ multiCurrencySelections });
    const selections = multiCurrencySelections.map(selection => selection.value);
    return this.setState({ multiCurrencySelections: selections });
  };

  onChangeLabels = () => {
    const previousDisplayFullname = this.state.displayFullName;
    this.setState({ displayFullName: !previousDisplayFullname });
  };

  render() {
    const { currency, disabled, disabledCurrencies, symbol, displayFullName, multiCurrencySelections } = this.state;
    return (
      <div>
        <Checkbox label="Show full currency name." checked={displayFullName} onChange={this.onChangeLabels} />
        <Checkbox
          label="Disable some currencies."
          checked={disabledCurrencies}
          onChange={this.onChangeDisabledCurrencies}
        />
        <div className="row">
          <div className="col-md-6">
            <CurrencySelector
              clearable={true}
              currency={currency}
              disabled={disabled}
              disabledCurrencies={disabledCurrencies ? DISABLED_CURRENCIES : null}
              required={true}
              onChange={this.onChange}
              displayFullName={displayFullName}
            />
          </div>
          {currency ? <div>Your product costs {symbol}5.</div> : null}
        </div>
        <div className="row">
          <div className="col-md-6">
            <CurrencySelector
              clearable={true}
              currency={multiCurrencySelections}
              disabled={disabled}
              disabledCurrencies={disabledCurrencies ? DISABLED_CURRENCIES : null}
              label="Select multiple currencies"
              isMulti
              required={true}
              onChange={this.onChangeMultiSelect}
              displayFullName={displayFullName}
            />
          </div>
        </div>
        {/* Flags courtesy of twemoji: https://github.com/twitter/twemoji */}
      </div>
    );
  }
}
